import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../../config/supabaseConfig.ts';
//Componets
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import Select from '../../../components/Select';
import MultiSelect from '../../../components/MultiSelect';
//Icons
import { FaEye, FaEyeSlash, FaUser, FaEnvelope, FaLock, FaWhatsapp, FaProjectDiagram, FaUserAlt, FaMagic } from 'react-icons/fa';
//validations
import { validateRequired, validateEmail, validateMinLength,
  validateMaxLength, validateString, validateNumeric, validateMatch, validateProjectsClient } from '../../../utils/validations';
//toast
import { toastError, toastSuccess } from '../../../utils/toast';
import DraftBanner from '../../../components/DraftBanner';
import { useDraft } from '../../../hooks/useDraft';
//services
import { clientService } from '../../../services/clientService';
import { proyectService } from '../../../services/proyectService';
// === LEGACY BCRYPT — ELIMINAR DESPUÉS DE MIGRACIÓN ===
import bcrypt from 'bcryptjs';
// =====================================================
import { proyectsClientService } from '../../../services/proyectsClientService';

const AddCliente = () => {
  const location = useLocation();
  const { isEdit, userEdit } = location.state || { isEdit: false, userEdit: null };
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleGeneratePassword = () => {
    const chars = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789!@#$%&*';
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
    const pwd = Array.from(array).map(b => chars[b % chars.length]).join('');
    setUser(prev => ({ ...prev, password: pwd, confirm_password: pwd }));
    setShowPassword(true);
    setShowConfirmPassword(true);
    setErrors(prev => ({ ...prev, password: '', confirm_password: '' }));
  };
  const [proyectos, setProyectos] = useState([]);
  const [proyectsClient, setProyectsClient] = useState([]);
  const [user, setUser] = useState({
    full_name: '',
    email: '',
    session_name: '',
    whatsapp_number: '',
    password: '',
    confirm_password: '',
    project_id: '',
    status: 'active',
    created_at: new Date().toISOString(),
    last_access_time: null
  });
  // Borrador: lo escrito sobrevive si el admin sale de la pantalla (las contraseñas nunca se guardan)
  const [formLoaded, setFormLoaded] = useState(!isEdit);
  const draft = useDraft(`cliente:${isEdit ? userEdit?.id : 'new'}`, user, setUser, { ready: formLoaded, omit: ['password', 'confirm_password'] });

  const [errors, setErrors] = useState({
    full_name: '',
    email: '',
    session_name: '',
    password: '',
    confirm_password: '',
    project_id: '',
  });

  useEffect(() => {
    const fetchProyectos = async () => {
      try {
        const data = await proyectService.getAll();
        const options = data.map(proyecto => ({
          value: proyecto.id,
          label: proyecto.name
        }));
        setProyectos(options);
      } catch (error) {
        console.error('Error al cargar proyectos:', error);
        toastError('Error al cargar la lista de proyectos');
      }
    };
    fetchProyectos();
  }, []);

  useEffect(() => {
    if (isEdit && userEdit) {
      setUser({
        full_name: userEdit.full_name,
        email: userEdit.email,
        session_name: userEdit.session_name,
        whatsapp_number: userEdit.whatsapp_number?.replace('+52', '') || '',
        project_id: userEdit.project_id,
        status: userEdit.status,
        created_at: userEdit.created_at,
        last_access_time: userEdit.last_access_time,
        password: '',
        confirm_password: '',
      });
      const proyectoIds = [];
      userEdit.proyectos.forEach(proyecto => {
        proyectoIds.push(proyecto.proyecto?.id);
      });
      setProyectsClient(proyectoIds);
      setFormLoaded(true);
    }
  }, [isEdit, userEdit]);

  // ── Validaciones ──────────────────────────────────────────
  const validateFullNameField = () => {
    let error = validateRequired(user.full_name)
    || validateMinLength(user.full_name, 3, 'El nombre debe tener al menos 3 caracteres')
    || validateMaxLength(user.full_name, 100, 'El nombre debe tener menos de 100 caracteres')
    || validateString(user.full_name, 'El nombre debe contener solo letras y espacios');
    setErrors(prev => ({ ...prev, full_name: error || '' }));
    return !error;
  };

  const validateEmailField = () => {
    let error = validateRequired(user.email) || validateEmail(user.email);
    setErrors(prev => ({ ...prev, email: error || '' }));
    return !error;
  };

  const validateSessionNameField = () => {
    let error = validateRequired(user.session_name)
    || validateMinLength(user.session_name, 3, 'El nombre de sesión debe tener al menos 3 caracteres')
    || validateMaxLength(user.session_name, 100, 'El nombre de sesión debe tener menos de 100 caracteres')
    setErrors(prev => ({ ...prev, session_name: error || '' }));
    return !error;
  };

  // En creación: obligatoria. En edición: opcional (solo si se ingresó algo)
  const validatePasswordField = () => {
    if (isEdit && !user.password) {
      setErrors(prev => ({ ...prev, password: '' }));
      return true;
    }
    let error = validateRequired(user.password)
    || validateMinLength(user.password, 6, 'La contraseña debe tener al menos 6 caracteres');
    setErrors(prev => ({ ...prev, password: error || '' }));
    return !error;
  };

  const validateConfirmPasswordField = () => {
    if (isEdit && !user.password && !user.confirm_password) {
      setErrors(prev => ({ ...prev, confirm_password: '' }));
      return true;
    }
    let error = validateRequired(user.confirm_password)
    || validateMinLength(user.confirm_password, 6, 'La confirmación de contraseña debe tener al menos 6 caracteres')
    || validateMatch(user.password, user.confirm_password);
    setErrors(prev => ({ ...prev, confirm_password: error || '' }));
    return !error;
  };

  const validateProjectIdField = () => {
    let error = validateProjectsClient(proyectsClient)
    setErrors(prev => ({ ...prev, project_id: error || '' }));
    return !error;
  };

  const validateAll = () => {
    const isFullNameValid = validateFullNameField();
    const isEmailValid = validateEmailField();
    const isSessionNameValid = validateSessionNameField();
    const isPasswordValid = validatePasswordField();
    const isConfirmPasswordValid = validateConfirmPasswordField();
    const isProyectsClientValid = validateProjectIdField();
    return isFullNameValid && isEmailValid && isSessionNameValid &&
           isPasswordValid && isConfirmPasswordValid &&
           isProyectsClientValid;
  };

  // ── Crear cliente ─────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateAll()) {
      toastError('Por favor, complete todos los campos requeridos correctamente');
      return;
    }

    try {
      // 1. Crear auth user
      const { data: authData, error: authError } = await supabase.functions.invoke('create-client-user', {
        body: {
          email: user.email,
          password: user.password,
          full_name: user.full_name,
        },
      });

      const funcError = authError || (authData?.error ? new Error(authData.error) : null);
      if (funcError || !authData?.id) {
        const msg = authData?.error || funcError?.message || 'Error al crear usuario de autenticación';
        toastError(msg);
        console.error('[handleSubmit] edge function error:', funcError, authData);
        return;
      }

      // === LEGACY BCRYPT — ELIMINAR DESPUÉS DE MIGRACIÓN ===
      const legacyHash = bcrypt.hashSync(user.password, 12);
      // =====================================================

      // 2. Crear cliente con auth_user_id
      const clientData = {
        full_name: user.full_name,
        session_name: user.session_name,
        email: user.email,
        whatsapp_number: user.whatsapp_number
          ? '+52' + user.whatsapp_number.replace(/\D/g, '')
          : null,
        status: user.status,
        auth_user_id: authData.id,
        password: legacyHash, // LEGACY
      };

      const { data, error } = await clientService.addClient(clientData);
      if (error) {
        toastError(error.message || 'Error al crear el cliente');
        return;
      }
      getProyectsClient(data.id);
    } catch (error) {
      console.error('Error al crear cliente:', error);
      toastError(error.message || 'Error al crear el cliente');
    }
  };

  // ── Editar cliente ────────────────────────────────────────
  const handleEdit = async () => {
    if (!validateAll()) {
      toastError('Por favor, complete todos los campos requeridos correctamente');
      return;
    }

    try {
      const emailChanged = user.email !== userEdit.email;
      const passwordChanged = !!user.password;

      // 1. Si tiene auth_user_id y cambió email o contraseña → sincronizar con auth.users
      if (userEdit.auth_user_id && (emailChanged || passwordChanged)) {
        const authUpdates = {};
        if (emailChanged)    authUpdates.email    = user.email;
        if (passwordChanged) authUpdates.password = user.password;

        const { data: authData, error: authError } = await supabase.functions.invoke('update-client-user', {
          body: { auth_user_id: userEdit.auth_user_id, ...authUpdates },
        });

        const funcError = authError || (authData?.error ? new Error(authData.error) : null);
        if (funcError) {
          const msg = authData?.error || funcError?.message || 'Error al actualizar credenciales';
          toastError(msg);
          console.error('[handleEdit] update-client-user error:', funcError, authData);
          return;
        }
      }

      // === LEGACY BCRYPT — ELIMINAR DESPUÉS DE MIGRACIÓN ===
      const legacyHash = passwordChanged ? bcrypt.hashSync(user.password, 12) : undefined;
      // =====================================================

      // 2. Actualizar datos en clientes_usuario
      const clientData = {
        full_name: user.full_name,
        session_name: user.session_name,
        email: user.email,
        whatsapp_number: user.whatsapp_number
          ? '+52' + user.whatsapp_number.replace(/\D/g, '')
          : null,
        status: user.status,
        ...(legacyHash ? { password: legacyHash } : {}), // LEGACY
      };

      const { error } = await clientService.editClient(userEdit.id, clientData);
      if (error) {
        toastError(error.message || 'Error al editar el cliente');
        return;
      }
      getProyectsClient(userEdit.id);
    } catch (error) {
      console.error('Error al editar cliente:', error);
      toastError(error.message || 'Error al editar el cliente');
    }
  };

  // ── Proyectos ─────────────────────────────────────────────
  const getProyectsClient = async (id) => {
    if (proyectsClient.length === 0) return;
    try {
      if (isEdit) {
        const { error } = await proyectsClientService.removeProyectClient(id);
        if (error) {
          toastError(error.message || 'Error al eliminar los proyectos del cliente');
          return;
        }
      }
      const { error } = await proyectsClientService.addProyectClient(proyectsClient, id);
      if (error) {
        toastError(error.message || 'Error al asignar los proyectos al cliente');
      } else {
        toastSuccess(isEdit ? 'Cliente editado exitosamente' : 'Cliente creado exitosamente');
        draft.clear();
        navigate('/clients');
      }
    } catch (error) {
      toastError(error.message || 'Error al asignar los proyectos al cliente');
    }
  };

  const handleProyectsClientChange = (e) => {
    if (e.target.value.length > 0) {
      setProyectsClient(e.target.value);
    } else {
      setProyectsClient([]);
    }
  };

  // ── Render ────────────────────────────────────────────────
  return (
    <div className="bg-surface-card border border-white/[0.06] rounded-xl p-6">
      <h2 className="text-xl font-semibold mb-6" style={{ color: 'rgb(var(--fg))' }}>{isEdit ? 'Editar Cliente' : 'Nuevo Cliente'}</h2>
      <DraftBanner restoredAt={draft.restoredAt} onDiscard={draft.discard} />
      <div className="flex items-center gap-4 mt-10">
        <Input
          label="Nombre Completo"
          name="full_name"
          type="text"
          required
          size='lg'
          value={user.full_name}
          leftIcon={<FaUser />}
          onChange={(e) => {
            setUser({ ...user, full_name: e.target.value });
            validateFullNameField();
          }}
          error={errors.full_name}
        />
        <Input
          label="Nombre de sesión"
          name="session_name"
          type="text"
          required
          size='lg'
          value={user.session_name}
          leftIcon={<FaUserAlt />}
          onChange={(e) => {
            setUser({ ...user, session_name: e.target.value });
            validateSessionNameField();
          }}
          error={errors.session_name}
        />
        <Input
          label="Correo Electrónico"
          name="email"
          type="email"
          required
          size='lg'
          value={user.email}
          leftIcon={<FaEnvelope />}
          onChange={(e) => {
            setUser({ ...user, email: e.target.value });
            validateEmailField();
          }}
          error={errors.email}
        />
      </div>
      <div className="flex items-start gap-2 mt-10">
        <Input
          label="Número de Whatsapp"
          name="whatsapp_number"
          type="text"
          size='lg'
          value={user.whatsapp_number}
          leftIcon={<FaWhatsapp />}
          onChange={(e) => {
            setUser({ ...user, whatsapp_number: e.target.value });
          }}
          error={errors.whatsapp_number}
        />
        <div className="w-full">
          <div className="flex items-center justify-between mb-1.5 ml-0.5">
            <label className="text-xs font-semibold" style={{ color: 'rgb(var(--fg-dim))', letterSpacing: '0.03em' }}>
              {isEdit ? 'Nueva contraseña (opcional)' : 'Contraseña'}
              {!isEdit && <span style={{ color: '#DC1F26', marginLeft: 3 }}>*</span>}
            </label>
            <button
              type="button"
              onClick={handleGeneratePassword}
              className="flex items-center gap-1 text-xs font-medium transition-colors"
              style={{ color: '#3B82F6' }}
              onMouseEnter={e => e.currentTarget.style.color = '#60A5FA'}
              onMouseLeave={e => e.currentTarget.style.color = '#3B82F6'}
            >
              <FaMagic size={10} /> Sugerir contraseña
            </button>
          </div>
          <Input
            name="password"
            type={showPassword ? 'text' : 'password'}
            required={!isEdit}
            size='lg'
            value={user.password}
            leftIcon={<FaLock />}
            rightIcon={showPassword ? <FaEyeSlash /> : <FaEye />}
            onRightIconClick={() => setShowPassword(!showPassword)}
            onChange={(e) => {
              setUser({ ...user, password: e.target.value });
              validatePasswordField();
            }}
            error={errors.password}
          />
        </div>
        <Input
          label={isEdit ? 'Confirmar nueva contraseña' : 'Confirmar Contraseña'}
          name="confirm_password"
          type={showConfirmPassword ? 'text' : 'password'}
          required={!isEdit}
          size='lg'
          value={user.confirm_password}
          leftIcon={<FaLock />}
          rightIcon={showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
          onRightIconClick={() => setShowConfirmPassword(!showConfirmPassword)}
          onChange={(e) => {
            setUser({ ...user, confirm_password: e.target.value });
            validateConfirmPasswordField();
          }}
          error={errors.confirm_password}
        />
      </div>
      {isEdit && !userEdit?.auth_user_id && (
        <p className="mt-2 text-sm text-yellow-600">
          ⚠️ Este cliente no tiene usuario de autenticación. Los cambios de contraseña no se aplicarán hasta que esté vinculado.
        </p>
      )}
      <div className="flex items-center gap-2 mt-10 w-[40%]">
        <MultiSelect
          id="project_id"
          name="project_id"
          label="Proyecto"
          options={proyectos}
          value={proyectsClient}
          onChange={handleProyectsClientChange}
          placeholder="Selecciona un proyecto"
          error={errors.project_id}
          isSearchable={true}
          className='w-[80%] h-[40px] rounded-[20px]'
        />
      </div>
      <div className="flex justify-end mt-10 gap-6">
        <Button
          variant="warning"
          onClick={() => navigate('/clients')}
          className='w-[20%] h-[40px] rounded-[20px]'
        >
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={isEdit ? handleEdit : handleSubmit}
          className='w-[20%] h-[40px] rounded-[20px]'
        >
          {isEdit ? 'Guardar cambios' : 'Guardar'}
        </Button>
      </div>
    </div>
  );
};

export default AddCliente;
